import _defineProperty from "/var/www/html/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import Store from "./Store";
import User from "./User";
import Image from "../library/Image";
import { SalePage } from "./SalePage";
import { getBlockInstance, toBase64 } from "../../../assets/js/mcn-helpers";
import Addons from "./Addons";
import Model from "./Model";
export class PreSellPage extends Model {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "Id", {
      id: 'pre-sell-page-id',
      fieldName: 'id',
      fieldTitle: 'Pre-sell page id',
      content: null
    });
    _defineProperty(this, "UpdatedUserID", {
      id: 'pre-sell-page-user-id',
      fieldName: 'user_id',
      fieldTitle: 'Pre-sell page user id',
      content: null
    });
    _defineProperty(this, "UpdatedUser", {
      id: 'pre-sell-page-updated-by',
      fieldName: 'last_updated_user',
      fieldTitle: 'Pre-sell page updated by',
      model: User,
      content: null
    });
    _defineProperty(this, "Owner", {
      id: 'pre-sell-page-user',
      fieldName: 'owner',
      fieldTitle: 'Pre-sell page user',
      model: User,
      content: null
    });
    _defineProperty(this, "SalePage", {
      id: 'pre-sell-page-sale-page',
      fieldName: 'sale_page',
      fieldTitle: 'Pre-sell page sale page',
      model: SalePage,
      content: null
    });
    _defineProperty(this, "SalePageID", {
      id: 'pre-sell-page-sale-page-id',
      fieldName: 'sale_page_id',
      fieldTitle: 'Pre-sell sale page id',
      content: null
    });
    _defineProperty(this, "DomainID", {
      id: 'pre-sell-page-domain-id',
      fieldName: 'domain_id',
      fieldTitle: 'Pre-sell page domain id',
      content: null
    });
    _defineProperty(this, "Domain", {
      id: 'pre-sell-page-domain',
      fieldName: 'domain',
      fieldTitle: 'Pre-sell page domain',
      model: Store,
      content: null
    });
    _defineProperty(this, "Status", {
      id: 'pre-sell-page-status',
      fieldName: 'status',
      fieldTitle: 'Pre-sell page status',
      content: null
    });
    // Language = {
    //     id: 'pre-sell-page-language',
    //     fieldName: 'language',
    //     fieldTitle: 'Pre-sell page language',
    //     content: null
    // }
    _defineProperty(this, "Blocks", {
      id: 'pre-sell-page-blocks',
      fieldName: 'blocks',
      fieldTitle: 'Pre-sell page Blocks',
      dynamicModel: block => getBlockInstance(block === null || block === void 0 ? void 0 : block.type),
      content: []
    });
    _defineProperty(this, "Title", {
      id: 'pre-sell-page-title',
      fieldName: 'title',
      fieldTitle: 'Pre-sell page title',
      content: null
    });
    _defineProperty(this, "UrlTitle", {
      id: 'pre-sell-page-url-title',
      fieldName: 'url_title',
      fieldTitle: 'Pre-sell page url title',
      content: null
    });
    _defineProperty(this, "FeaturedImage", {
      id: 'pre-sell-page-image',
      fieldName: 'featured_image',
      fieldTitle: 'Pre-sell page image',
      model: Image,
      content: null
    });
    _defineProperty(this, "Pixels", {
      id: 'pre-sell-page-pixel',
      fieldName: 'pixels',
      fieldTitle: 'Pre-sell page pixels',
      type: 'json',
      content: null
    });
    _defineProperty(this, "Addons", {
      id: 'pre-sell-page-addon',
      fieldName: 'addons',
      fieldTitle: 'Pre-sell page addon',
      model: Addons,
      content: null
    });
    _defineProperty(this, "VisitsCount", {
      fieldName: 'visit_logs_count',
      content: 0
    });
    _defineProperty(this, "ClicksCount", {
      fieldName: 'clicks_count',
      content: 0
    });
  }
  getId() {
    return this.Id.content;
  }
  getDomainId() {
    var _this$DomainID;
    return (_this$DomainID = this.DomainID) === null || _this$DomainID === void 0 ? void 0 : _this$DomainID.content;
  }
  getPageId() {
    var _this$Id;
    return (_this$Id = this.Id) === null || _this$Id === void 0 ? void 0 : _this$Id.content;
  }
  getPageTitle() {
    var _this$Title;
    return (_this$Title = this.Title) === null || _this$Title === void 0 ? void 0 : _this$Title.content;
  }
  getTitle() {
    var _this$Title2;
    return (_this$Title2 = this.Title) === null || _this$Title2 === void 0 ? void 0 : _this$Title2.content;
  }
  getPageFeaturedImage() {
    var _this$FeaturedImage;
    return (_this$FeaturedImage = this.FeaturedImage) === null || _this$FeaturedImage === void 0 ? void 0 : _this$FeaturedImage.content;
  }
  getPageFeaturedImageUrl() {
    var _this$getPageFeatured;
    return (_this$getPageFeatured = this.getPageFeaturedImage()) === null || _this$getPageFeatured === void 0 ? void 0 : _this$getPageFeatured.getImageUrl();
  }
  getPageUrlTitle() {
    var _this$UrlTitle;
    return (_this$UrlTitle = this.UrlTitle) === null || _this$UrlTitle === void 0 ? void 0 : _this$UrlTitle.content;
  }
  getDomain() {
    var _this$Domain;
    return (_this$Domain = this.Domain) === null || _this$Domain === void 0 ? void 0 : _this$Domain.content;
  }
  getSalePage() {
    var _this$SalePage;
    return (_this$SalePage = this.SalePage) === null || _this$SalePage === void 0 ? void 0 : _this$SalePage.content;
  }
  hasDomainDnsActive() {
    let salePage = this.getSalePage();
    return salePage instanceof SalePage ? salePage.hasDomainDnsActive() : false;
  }
  hasDomainSslActive() {
    let salePage = this.getSalePage();
    return salePage instanceof SalePage ? salePage.hasDomainSslActive() : false;
  }
  getCountry() {
    var _this$getSalePage;
    return (_this$getSalePage = this.getSalePage()) === null || _this$getSalePage === void 0 ? void 0 : _this$getSalePage.getOfferCountry();
  }
  getCountryName(lang) {
    var _this$getCountry;
    return (_this$getCountry = this.getCountry()) === null || _this$getCountry === void 0 ? void 0 : _this$getCountry.getCountryTranslation(lang);
  }
  getOwner() {
    var _this$Owner;
    return (_this$Owner = this.Owner) === null || _this$Owner === void 0 ? void 0 : _this$Owner.content;
  }
  getLastUpdatedUser() {
    var _this$UpdatedUser;
    return (_this$UpdatedUser = this.UpdatedUser) === null || _this$UpdatedUser === void 0 ? void 0 : _this$UpdatedUser.content;
  }
  getLastUpdatedUserName() {
    var _this$getLastUpdatedU, _this$getLastUpdatedU2;
    return (_this$getLastUpdatedU = this.getLastUpdatedUser()) === null || _this$getLastUpdatedU === void 0 || (_this$getLastUpdatedU2 = _this$getLastUpdatedU.getUserName) === null || _this$getLastUpdatedU2 === void 0 ? void 0 : _this$getLastUpdatedU2.call(_this$getLastUpdatedU);
  }
  getLastUpdatedUserRoleName() {
    var _this$getLastUpdatedU3, _this$getLastUpdatedU4, _this$getLastUpdatedU5;
    return (_this$getLastUpdatedU3 = this.getLastUpdatedUser()) === null || _this$getLastUpdatedU3 === void 0 || (_this$getLastUpdatedU4 = _this$getLastUpdatedU3.getUserRole) === null || _this$getLastUpdatedU4 === void 0 || (_this$getLastUpdatedU4 = _this$getLastUpdatedU4.call(_this$getLastUpdatedU3)) === null || _this$getLastUpdatedU4 === void 0 || (_this$getLastUpdatedU5 = _this$getLastUpdatedU4.getRoleName) === null || _this$getLastUpdatedU5 === void 0 ? void 0 : _this$getLastUpdatedU5.call(_this$getLastUpdatedU4);
  }
  getOwnerName() {
    var _this$getOwner, _this$getOwner$getUse;
    return (_this$getOwner = this.getOwner()) === null || _this$getOwner === void 0 || (_this$getOwner$getUse = _this$getOwner.getUserName) === null || _this$getOwner$getUse === void 0 ? void 0 : _this$getOwner$getUse.call(_this$getOwner);
  }
  getOwnerRoleName() {
    var _this$getOwner2, _this$getOwner2$getUs, _this$getOwner2$getUs2;
    return (_this$getOwner2 = this.getOwner()) === null || _this$getOwner2 === void 0 || (_this$getOwner2$getUs = _this$getOwner2.getUserRole) === null || _this$getOwner2$getUs === void 0 || (_this$getOwner2$getUs = _this$getOwner2$getUs.call(_this$getOwner2)) === null || _this$getOwner2$getUs === void 0 || (_this$getOwner2$getUs2 = _this$getOwner2$getUs.getRoleName) === null || _this$getOwner2$getUs2 === void 0 ? void 0 : _this$getOwner2$getUs2.call(_this$getOwner2$getUs);
  }
  getPreSellPageUrl() {
    let domain = this.getDomain();
    let domain_name = process.env.VUE_APP_PAGE_DEFUALT_DOMAIN;
    if (domain instanceof Store) {
      let protocol = domain.isSSL() ? 'https://' : 'http://';
      domain_name = [protocol, domain.getDomainName()].join('');
    }
    return [domain_name, 'blogs', this.getPageUrlTitle(), toBase64(this.getPageId())].join('/');
  }
  getUrl() {
    let domain = this.getDomain();
    let domain_name = process.env.VUE_APP_PAGE_DEFUALT_DOMAIN;
    if (domain instanceof Store) {
      let protocol = domain.isSSL() ? 'https://' : 'http://';
      domain_name = [protocol, domain.getDomainName()].join('');
    }
    return [domain_name, 'blogs', this.getPageUrlTitle(), toBase64(this.getPageId())].join('/');
  }
  getLink() {
    return this.getUrl();
  }
  getPreSellPageSelectObject(text = 'text', value = 'value') {
    var _this$Title3, _this$Id2;
    return {
      [text]: (_this$Title3 = this.Title) === null || _this$Title3 === void 0 ? void 0 : _this$Title3.content,
      [value]: (_this$Id2 = this.Id) === null || _this$Id2 === void 0 ? void 0 : _this$Id2.content
    };
  }
}
_defineProperty(PreSellPage, "ACTIVE_STATUS", 'active');
_defineProperty(PreSellPage, "INACTIVE_STATUS", 'inactive');
export default PreSellPage;